import {createApp, nextTick} from "vue";
const axios = require('axios');


export default {
    name: 'workshop',
    _container: null,
    _retailers: null,
    _selector  : '#js_workshop',
    init() {
        console.log('workshop');
        this._container = document.querySelector(this._selector);
        console.log(this._container);

        if (this._container) {
            this.run();
        }
    },
    run() {
        const siteId = JSON.parse(this._container.getAttribute('data-siteid'));

        let regNumber = '';
        let chassisNo = '';
        let firstName = '';
        let lastName = '';
        let email = '';
        let phone = null;
        let message = '';
        let campingSiteKey = '';
        let campingSiteNo = '';
        let campingSiteName = '';
        let insuranceCompany = '';
        let insuranceEmail = '';
        let damageNumber = '';
        let coPayment = '';
        let mileage = '';
        let street = '';
        let zipcode = '';
        let city = '';

        const queryString = window.location.search;
        if (queryString.search('test=workshop') !== -1 || window.location.href.includes('.test')) {
            firstName = 'Ola';
            lastName = 'Nordmann';
            // email = 'email.' + Math.floor(Math.random() * 9999) + '@example.com';
            email = 'test@example.com';
            phone = '12345679';
            message = 'Test :-)';
            regNumber = 'CU09460';
            campingSiteKey = 'lorem';
            campingSiteNo = '123';
            campingSiteName = 'Tellus Camping';
            mileage = '123456';
            street = 'Kanonveien 9';
            zipcode = '0001';
            city = 'Oslo';
            insuranceCompany = 'Min forsikring';
            insuranceEmail = 'forsikring@example.com';
            damageNumber = '00000000';
        }

        const app = createApp({
            delimiters: ['@{', '}'],
            data() {
                return {
                    a: 'workshop',
                    administrationFee: false,
                    attachment: null,
                    attachmentClass: '',
                    brandName: '',
                    campingSiteKey: campingSiteKey,
                    campingSiteName: campingSiteName,
                    campingSiteNo: campingSiteNo,
                    chassisNo: chassisNo,
                    city: city,
                    countryCode: 'no',
                    coPayment: coPayment,
                    currentRetailer: null,
                    damageNumber: damageNumber,
                    email: '',
                    firstName: firstName,
                    hasRegNo: '1',
                    validation: false,
                    lastName: lastName,
                    item: null,
                    insuranceCompany: insuranceCompany,
                    insuranceEmail: insuranceEmail,
                    gdpr: false,
                    lat: null,
                    lng: null,
                    message: message,
                    mileage: mileage,
                    modelName: '',
                    newsletter: false,
                    phone: phone,
                    publicItems: [],
                    regNumber: regNumber,
                    responseStatus: '',
                    responseMessage: '',
                    retailerId: '',
                    retailerList: [],
                    siteId: siteId,
                    street: street,
                    step: 1,
                    subject: 'Verkstedskjema ',
                    services: [],
                    type: 'service',
                    userId: email,
                    yearModel: '',
                    zipcode: zipcode
                }

            },
            created() {
                this.redirect = window.location.href;
                // this.getRetailers();

                document.getElementById('js_workshop').classList.add('is-ready');
            },

            computed:
            {
                validStep() {
                    const validation = this.validation;
                    const query = '.workshop__step--' + this.step + ' .required-field';
                    const fields = document.querySelectorAll(query);

                    let isValid = true;

                    fields.forEach((field) => {
                        let fieldName = field.name;

                        // console.log(this[fieldName]);
                        if (this[fieldName] !== null && this[fieldName].length === 0 || this[fieldName] === false) {
                            isValid = false;
                        }
                    });


                    // check if vehicle object (data from vegvesen) is loaded
                    if (this.hasRegNo === '1' && this.item === null) {
                        isValid = false;
                    }

                    // check if attachment < 5 MB
                    if (this.step === 2 && this.attachment !== null) {
                        isValid = (this.attachmentClass === '');
                    }

                    return isValid;
                },

                isOnSiteService() {
                    return (this.type === 'onsite_service');
                },

                responseStatusClass() {
                    return  (this.responseStatus && this.responseStatus.length ) ?
                        `alert--${this.responseStatus}` :
                        '';
                },
            },

            methods:
            {
                nextStep() {
                    this.step += 1;
                    this.scrollToForm();
                },

                prevStep() {
                    this.step -= 1;
                    this.scrollToForm();
                },

                isActiveTab(stepId) {
                    return stepId === this.step ? 'active' : '';
                },

                scrollToForm() {
                    const el = document.getElementById('workshop-pagination');
                    // el.style.top = (el.offsetTop-100) +"px";
                    el.scrollIntoView({block: "start", behavior: "smooth"});
                },

                isActiveInquiryType(inquiryType) {
                  return this.type === inquiryType ? 'button-primary--active' : '';
                },

                getCityByZipcode() {
                    if (!this.zipcode || !this.countryCode) {
                        // console.info('missing zipcode/countryCode');
                        return false;
                    }

                    const queryArgs = {
                        country_code: this.countryCode,
                        zipcode: this.zipcode,
                    }

                    this.rest('/actions/mm/location/index', queryArgs, 'getCityByZipcode__callback');
                },

                getCityByZipcode__callback(response) {
                    const attr = 'place name';
                    if (typeof response === 'object' && typeof response.data === 'object' && typeof response.data.places[0][attr] !== 'undefined') {
                        this.city = response.data.places[0][attr];
                    }
                },

                findRetailerById(item) {
                    return (item.id == this.retailerId) ? true : false;
                },

                validateAttachment() {
                    this.attachment = this.$refs.attachment;
                    // console.log(this.attachment);
                    const file = (this.attachment && typeof this.attachment.files !== 'undefined') ?
                        this.$refs.attachment.files[0] :
                        null;

                    const limit = 1024 * 1024 * 5; // 5 MB
                    this.attachmentClass = (file && file.size > limit) ?
                        'error' :
                        '';
                },

                hasRegNoChanged() {
                    setTimeout(() => this.validation = !this.validation, 200);
                },

                isServiceChecked(service) {
                    return (this.services.includes(service)) ?
                        'default-checkbox--active' :
                        '';
                },

                onSubmit(event) {
                    // console.log('submit');
                    // console.log(event);
                    const headers = {"Content-Type": "multipart/form-data"};
                    const postData = this.prepareData();
                    const url = '/actions/mm/mail/store';

                    this.responseStatus = 'info';
                    this.responseMessage = 'Sender forespørsel';

                    axios.post(url, postData, headers)
                        .then(this.onSubmit__callback)
                        .catch(this.axios__error);
                },

                onSubmit__callback(response) {
                    // console.log('onSubmit__callback');
                    if (typeof response === 'object' && typeof response.data === 'object') {
                        this.responseMessage = response.data.message;
                        this.responseStatus = 'ok';
                    }
                },

                getPostArgs() {
                    let brandName = this.brandName;
                    let modelName = this.modelName;
                    let yearModel = this.yearModel;
                    if (this.hasRegNo === '1') {
                        brandName = this.item?.merkenavn;
                        modelName = this.item?.modell;
                        yearModel = this.item?.reg_aar;
                    }

                    const postData = {
                        brand_name : brandName,
                        chassis_no : this.chassisNo,
                        city: this.city,
                        country : this.countryCode,
                        email : this.userId,
                        first_name : this.firstName,
                        gdpr : this.gdpr,
                        honeypot : document.getElementById('email').value,
                        last_name : this.lastName,
                        message: this.message,
                        model: modelName,
                        mobile: this.phone,
                        newsletter: this.newsletter,
                        retailerId: this.retailerId,
                        redirect: this.redirect,
                        reg_number: this.regNumber,
                        mileage: this.mileage,
                        type: this.type,
                        services: this.services.join(','),
                        street: this.street,
                        subject: this.subject,
                        zipcode: this.zipcode,
                        year_model: yearModel,
                    };

                    // if type === onsite_service
                    if (this.campingSiteName) {
                        postData.camping_site_name = this.campingSiteName;
                    }

                    if (this.campingSiteNo) {
                        postData.camping_site_no = this.campingSiteNo;
                    }

                    if (this.campingSiteKey) {
                        postData.camping_site_key = this.campingSiteKey;
                    }

                    // if type === insurance
                    if (this.damageNumber) {
                        postData.damage_number = this.damageNumber;
                    }

                    if (this.insuranceCompany) {
                        postData.insurance_company = this.insuranceCompany;
                    }

                    if (this.insuranceEmail) {
                        postData.insurance_email = this.insuranceEmail;
                    }

                    if (this.administrationFee) {
                        postData.administration_fee = this.administrationFee;
                    }

                    if (this.coPayment) {
                        postData.co_payment = this.coPayment;
                    }

                    console.log(postData);

                    return postData;
                },

                prepareData() {
                    const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                    const postData = this.getPostArgs();

                    const bodyFormData = new FormData();
                    for (let attr in postData) {
                        // console.log(attr +  ' '+postData[attr]);
                        bodyFormData.append(attr, postData[attr]);
                    }

                    if (typeof this.attachment !== 'undefined' && this.attachment !== null && this.attachment.files.length === 1) {
                        bodyFormData.append('attachment', this.attachment.files[0]);
                    }

                    return bodyFormData;
                },


                findRegNumber() {
                    this.regNumber = this.regNumber.replaceAll(' ', '');
                    const endpoint = '/actions/mm/regnr/get-vehicle';
                    const queryArgs = {reg_number: this.regNumber};

                    this.rest(endpoint, queryArgs, 'findRegNumber__callback');
                },

                findRegNumber__callback(response) {
                    if (response.data.item && typeof response.data.item === 'object') {
                        this.item = response.data.item;
                        this.chassisNo = response.data.item.chassis_no;
                    } else {
                        this.responseStatus = 'error';
                        this.responseMessage = 'Registreringsnummeret ble ikke funnet';
                    }
                },

                rest(endpoint, queryArgs, callback) {
                    this.responseStatus = this.responseMessage = '';

                    let queryString = "";
                    for (var i in queryArgs) {
                        queryString += i + "=" + queryArgs[i] + "&";
                    }
                    const url =  endpoint + "?" + queryString;

                    axios.get(url)
                        .then(this[callback])
                        .catch(function (error) {
                        });
                },

                axios__error(error) {
                    console.log('axios__error');
                    console.log(error);
                    this.responseStatus = 'error';
                    this.responseMessage = error;
                }
            }
         });

        console.log(app);

        app.mount(this._selector);

    }
}